export const FETCH_CART = 'fetchCart'
export const IMPORT_FILE = 'importFile'
export const ADD_CART_ITEM = 'addToCart'
export const UPDATE_CART_ITEM = 'updateCartItem'
export const REMOVE_CART_ITEM = 'removeCartItem'
export const CHECKOUT = 'checkout'
